/* Countless Bubble jQuery Plugin - v1.0
 * Copyright (c)2015 Matt Satorius, Sators.com Internet Solutions, Inc.
 * 2015-04-22
 */
(function ( $ ) {
 	var methods = {
        init : function(options) {
			// Default options.
	        var settings = $.extend({
	            // These are the defaults.
	            content: 'Error',
	            className: 'error',
	            side: 'right',
	            width: '75',
	            fadeInSpeed: 'slow',
	        }, options );
			this.wrap('<div style="position: relative" />')
			container_styles = {
				'width': settings.width,
			}
			var bubble_container = $('<div />').addClass('bubble ' + settings.className + ' ' + settings.side).css(container_styles).html(settings.content);

			var self = this;
			if(settings.side == 'left'){
				animate = {'left' : '+=10px'};
			} else {
				animate = {'right' : '+=10px'};
			}
	        setTimeout(function(){bubble_container.hide().appendTo(self.parent()).fadeIn(settings.fadeInSpeed).animate( animate, {duration: settings.fadeInSpeed, queue: false})}, 250);

			return this;
        },
        remove : function( ) {
	        if($.isFunction(this)){
	    		$('.bubble').fadeOut('fast', function(){$(this).unwrap().remove();});
	    	} else {
		    	if($(this).parent().attr('style') ==  'position: relative'){
			    	$(this).parent().find('.bubble').fadeOut('fast', function(){$(this).unwrap().remove();});
			    }
	    	}
	    }
    };
    var bubble_function = function(methodOrOptions) {
        if ( methods[methodOrOptions] ) {
            return methods[ methodOrOptions ].apply( this, Array.prototype.slice.call( arguments, 1 ));
        } else if ( typeof methodOrOptions === 'object' || ! methodOrOptions ) {
            // Default to "init"
            return methods.init.apply( this, arguments );
        } else {
            $.error( 'Method ' +  methodOrOptions + ' does not exist on jQuery.bubble' );
        }
    }
    $.fn.bubble = $.bubble = bubble_function;


}( jQuery ));